<template>
    <div class="o-crop">
        <template v-if="agriiProtector">
            <m-title :title="agriiProtector.name">
                <a-button
                    :icon="agriiProtector.is_favorite ? 'Favorite' : 'FavoriteLight'"
                    @click="$store.dispatch('agriiProtectorFavorite', agriiProtector.id)"
                    :is-processing="agriiProtectorStatus === 'settingFavorite'"
                />
                <a-button
                    icon="Note"
                    @click="$store.dispatch('modalShow', 'note')"
                />
                <a-button
                    v-if="agriiProtector.label_links && agriiProtector.label_links.length === 1"
                    class="m-title__button"
                    @click="openLabel(agriiProtector.label_links[0])"
                >
                    Etykieta
                </a-button>
                <a-button
                    v-if="agriiProtector.label_links && agriiProtector.label_links.length > 1"
                    class="m-title__button"
                    @click="showLabels = !showLabels"
                >
                    Etykiety
                </a-button>
                <div
                    v-if="agriiProtector.label_links && agriiProtector.label_links.length > 1 && showLabels"
                    class="o-protector__labels"
                >
                    <a
                        class="o-protector__labelsItem"
                        :href="label"
                        v-for="(label, labelIdx) in agriiProtector.label_links"
                        v-bind:key="`label${labelIdx}`"
                    >
                        Etykieta {{ labelIdx + 1 }}
                    </a>
                </div>
            </m-title>
            <div class="l-row" v-if="agriiProtector.description && descriptionWithoutTags">
                <div class="l-row__column">
                    <p class="a-label">Informacje o produkcie</p>
                    <div class="a-text" v-html="agriiProtector.description"></div>
                </div>
            </div>
            <m-note
                v-if="note"
                :content="note"
            ></m-note>
            <m-list-card
                v-if="agriiProtector.active_substances && agriiProtector.active_substances.length > 0"
                title="Substancje aktywne"
                icon="ActiveSubstances"
                :list="agriiProtector.active_substances"
            />
            <m-list-card
                v-if="agriiProtector.view_agrofags && agriiProtector.view_agrofags.length > 0"
                title="Agrofagi"
                icon="Agrofags"
                router-single-name="agrofag"
                :list="agriiProtector.view_agrofags"
            />
            <m-list-card
                v-if="agriiProtector.view_crops && agriiProtector.view_crops.length > 0"
                title="Uprawy"
                icon="Crops"
                router-single-name="crop"
                :list="agriiProtector.view_crops"
            />
            <div class="l-row">
                <div class="l-row__column">
                    <p class="a-label">Grupa</p>
                    <p
                        v-if="agriiProtector.agrii_protector_group"
                        class="a-text"
                    >
                        {{ agriiProtector.agrii_protector_group.name }}
                    </p>
                    <template v-if="agriiProtector.producer">
                        <p class="a-label">Producent</p>
                        <p class="a-text">{{ agriiProtector.producer.name }}</p>
                    </template>
                </div>
            </div>
            <m-gallery
                v-if="agriiProtector.photos && agriiProtector.photos.length > 0"
                :images="photos"
            />
            <br />
            <a-youtube
                v-if="agriiProtector.youtube_link"
                :src="agriiProtector.youtube_link"
            ></a-youtube>
            <m-list-card
                v-if="agriiProtector.nonpesticide_ingredients && agriiProtector.nonpesticide_ingredients.length > 0"
                title="Składniki"
                icon="ActiveSubstances"
                :list="agriiProtector.nonpesticide_ingredients"
            />
            <template v-if="!agriiProtector.nonpesticide_ingredients">
                <m-tabs
                    v-if="agriiProtectorsRelated"
                    :items="agriiProtectorsRelated"
                    @input="tab = $event.value"
                    :selected="tab"
                    :center="true"
                />
                <m-list
                    v-if="tab === 'ingredients'"
                    router-single-name="agrii-protector"
                    :list="agriiProtector.ingredients"
                >
                    <template slot="list" slot-scope="props">
                        <div class="m-list__itemPhoto">
                            <a-image
                                v-if="props.item.photos && props.item.photos.length > 0 && !!props.item.photos.find(item => item.is_main === true)"
                                :src="props.item.photos.find(item => item.is_main === true).full_uri"
                                :alt="props.item.name"
                            />
                            <figure
                                v-else
                                class="a-image"
                            ></figure>
                        </div>
                        <p
                            class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize"
                            :style="authIsAdvisor && props.item.position_group ? { color: props.item.position_group.hex } : false"
                        >
                            {{ props.item.name }}
                        </p>
                        <div class="m-list__itemIcons">
                            <a-icon
                                v-if="props.item.youtube_link"
                                class="m-list__icon"
                                icon="Video"
                            />
                            <a-icon
                                class="m-list__icon"
                                :icon="props.item.notes && props.item.notes.length > 0 ? 'Note' : 'NoteLight'"
                            />
                            <a-icon
                                class="m-list__icon"
                                :icon="props.item.is_favorite ? 'Favorite' : 'FavoriteLight'"
                            />
                        </div>
                    </template>
                </m-list>
            </template>
            <o-modal name="note">
                <p class="a-title a-title--small">
                    Notatka
                </p>
                <br />
                <textarea
                    placeholder="Treść notatki"
                    name="note"
                    class="a-control__textarea"
                    v-model="note"
                ></textarea>
                <template v-slot:actions>
                    <a-button
                        class="a-button--fullwidth a-button--smaller"
                        :process-on-click="true"
                        @click="submitNote"
                    >Zapisz</a-button>
                </template>
            </o-modal>
        </template>
        <a-spinner v-else />
    </div>
</template>

<script>
import MNote from '@/components/MNote'
export default {
    metaInfo() {
        return {
            title: this.metaTitle
        }
    },
    components: {
        MNote
    },
    data() {
        return {
            noteValue: '',
            tab: '',
            metaTitle: 'Środek'
        }
    },
    computed: {
        agriiProtector() {
            return this.$store.getters.agriiProtector
        },
        agriiProtectorStatus() {
            return this.$store.getters.agriiProtectorStatus
        },
        note: {
            get() {
                return this.$store.getters.agriiProtectorNote
            },
            set(note) {
                this.noteValue = note
            }
        },
        agriiProtectorsRelated() {
            if(this.agriiProtector.ingredients && this.agriiProtector.ingredients.length > 0) {
                return [{
                    value: 'ingredients',
                    label: 'Składniki'
                }]
            } else {
                return null
            }
        },
        descriptionWithoutTags() {
            return this.agriiProtector.description.replace(/(<([^>]+)>)/gi, '')
        },
        photos() {
            return this.agriiProtector.photos.map(item => item.full_uri)
        },
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        }
    },
    methods: {
        fetchAgriiProtector() {
            if(!isNaN(this.$route.params.id)) {
                this.$store.dispatch('fetchAgriiProtector', this.$route.params.id).then(() => {
                    this.metaTitle = this.agriiProtector.name
                    // init tabs
                    if(this.agriiProtector.ingredients && this.agriiProtector.ingredients.length > 0) {
                        this.tab = 'ingredients'
                    }
                })
            } else {
                this.$router.push({ name: 'error404' })
            }
        },
        submitNote() {
            this.$store.dispatch('submitNote', {
                id: this.agriiProtector.id,
                note: this.noteValue,
                model: 'agrii-protectors'
            }).then(() => {
                this.$store.dispatch('modalHide')
                this.$store.dispatch('addNotification', {
                    type: 'success',
                    content: 'Dodano notatkę'
                })
                this.fetchAgriiProtector()
            }).catch(() => {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: 'Wystąpił błąd podczas dodawania notatki.'
                })
            })
        },
        openLabel(url) {
            window.open(url, '_blank')
        }
    },
    created() {
        this.fetchAgriiProtector()
    }
}
</script>
